import {
  Component, EventEmitter, Input, OnInit, Output, ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import UserGenerator from 'src/app/classes/user.class';

@Component({
  selector: 'app-buildings-and-positions',
  templateUrl: './buildings-and-positions.component.html',
  styleUrls: [ './buildings-and-positions.component.scss' ],
})
export class BuildingsAndPositionsComponent {
  @ViewChild('buildinginput') buildingInput: any;
  @ViewChild('positioninput') positionInput: any;
  @Output() updateUserObject = new EventEmitter<object>();
  @Output() stepBack = new EventEmitter<any>();
  @Input() user: UserGenerator;
  @Input() isEditMode: boolean;
  @Input() permissions: any;
  @Input() buildings: any;
  @Input() positions: any;
  @Input() step: { text: string; completed: boolean; modified: boolean; };

  constructor(public dialog: MatDialog) { }

  filterPrimaryAsset(assets: number[], primaryAssetId: number) {
    return assets.filter((assetId) => assetId != primaryAssetId);
  }

  // #region BUILDINGS
  getBuildingName = (buildingId: number | string) => {
    if (!this.buildings) return;

    return this.buildings.find((building: any) => building.id == Number.parseInt(String(buildingId)))?.buildingName;
  }

  togglePrimaryAsset = (assetId: number, type: 'position' | 'building') => {
    if (type === 'building') {
      if (Number.parseInt(String(this.user.primaryBuildingId)) === Number.parseInt(String(assetId))) return;

      this.user.primaryBuildingId = Number.parseInt(String(assetId));
      this.user.buildingIds = [ ...new Set(this.user.buildingIds.map(item => Number.parseInt(String(item)))) ];

      return;
    } else if (type === 'position') {

      if (Number.parseInt(String(this.user.primaryPositionId)) === Number.parseInt(String(assetId))) return;

      this.user.primaryPositionId = Number.parseInt(String(assetId));
      this.user.positionIds = [ ...new Set(this.user.positionIds.map(item => Number.parseInt(String(item)))) ];

      return;
    }

    this.step.modified = true;
  }

  addBuilding = (event: Event) => {
    const buildingId = Number((event.target as HTMLInputElement).value);
    if (this.user.buildingIds.includes(Number.parseInt(String(buildingId)))) return;

    this.user.buildingIds = [ ...new Set([ ...this.user.buildingIds, Number.parseInt(String(buildingId)) ]) ];
    this.buildingInput.nativeElement.value = '';

    if (!this.user.primaryBuildingId) {
      this.user.primaryBuildingId = Number.parseInt(String(buildingId));
    }
    this.step.modified = true;
  }

  removeBuilding = (buildingId: number | string) => {
    const primaryBuildingId = Number.parseInt(String(this.user.primaryBuildingId));

    const isPrimary = primaryBuildingId === Number.parseInt(String(buildingId));

    const newBuildingsArr = this.user.buildingIds.filter((item: number) => Number.parseInt(String(item)) !== Number.parseInt(String(buildingId)));

    this.user.buildingIds = newBuildingsArr;

    if (isPrimary) {
      this.user.primaryBuildingId = newBuildingsArr[0];
    }

    this.step.modified = true;
  }



  // #endregion BUILDINGS

  // #region POSITIONS

  getPositionName = (positionId: number | string) => {
    if (!this.positions) return;

    return this.positions.find((position: any) => position.id == Number.parseInt(String(positionId)))?.positionTitle;
  }

  addPosition = (event: Event) => {
    const positionId = Number((event.target as HTMLInputElement).value);
    if (this.user.positionIds.includes(positionId)) return;

    this.user.positionIds = [ ...new Set([ ...this.user.positionIds, Number.parseInt(String(positionId)) ]) ];
    this.positionInput.nativeElement.value = '';

    if (!this.user.primaryPositionId) {
      this.user.primaryPositionId = positionId;
    }

    this.step.modified = true;
  }

  removePosition = (positionId: number | string) => {
    const primaryPositionId = Number.parseInt(String(this.user.primaryPositionId));

    const newPositonsArr = this.user.positionIds.filter((item: number) => Number.parseInt(String(item)) !== Number.parseInt(String(positionId)));

    this.user.positionIds = newPositonsArr;

    const isPrimary = primaryPositionId === Number.parseInt(String(positionId));
    if (isPrimary) {
      this.user.primaryPositionId = newPositonsArr[0];
      return;
    }

    this.step.modified = true;
  }

  // #endregion POSITIONS

  stepBackward = () => {
    this.stepBack.emit();
  }

  closeDialog = () => {
    this.dialog.closeAll();
  }

  updateUser = () => {
    if (!this.user.primaryBuildingId || !this.user.primaryPositionId) {
      return
    }
    this.updateUserObject.emit();
  }

}
